/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Cary Troubleshooting Guides API
 * Backend API for Cary troubleshooting guides
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import { customInstance } from '../../../shared/lib/api-client';
export type GetApiAdminSearchHistorySearchIdViewsParams = {
page?: number;
pageSize?: number;
};

export type GetApiAdminSearchHistoryClustersParams = {
StartDate?: string;
EndDate?: string;
MinClusterSize?: number;
MaxClusters?: number;
SimilarityThreshold?: number;
};

export type GetApiAdminSearchHistorySort = typeof GetApiAdminSearchHistorySort[keyof typeof GetApiAdminSearchHistorySort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiAdminSearchHistorySort = {
  'requestedAt:asc': 'requestedAt:asc',
  'requestedAt:desc': 'requestedAt:desc',
  'locale:asc': 'locale:asc',
  'locale:desc': 'locale:desc',
  'resultCount:asc': 'resultCount:asc',
  'resultCount:desc': 'resultCount:desc',
} as const;

export type GetApiAdminSearchHistoryParams = {
Problem?: string;
Locale?: string;
UserId?: string;
UserEmail?: string;
Manufacturer?: string;
ModelSeries?: string;
ModelYear?: number;
EngineType?: string;
EuroCode?: string;
StartDate?: string;
EndDate?: string;
MinResults?: number;
MaxResults?: number;
/**
 * Optional sorting parameter. Sorts the search history entries by the specified field in ascending or descending order. Format: 'field:direction' (e.g., 'requestedAt:desc', 'locale:asc', 'resultCount:desc').
 */
Sort?: GetApiAdminSearchHistorySort;
ExcludeSolved?: boolean;
IncludeVectors?: boolean;
Page?: number;
PageSize?: number;
};

export type GetApiAdminGuidesGuideIdViewsParams = {
page?: number;
pageSize?: number;
};

export type GetApiAdminGuidesSort = typeof GetApiAdminGuidesSort[keyof typeof GetApiAdminGuidesSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiAdminGuidesSort = {
  'status:asc': 'status:asc',
  'status:desc': 'status:desc',
  'createdAt:asc': 'createdAt:asc',
  'createdAt:desc': 'createdAt:desc',
  'updatedAt:asc': 'updatedAt:asc',
  'updatedAt:desc': 'updatedAt:desc',
} as const;

export type GetApiAdminGuidesParams = {
Brand?: string;
Model?: string;
ModelYear?: number;
EngineType?: EngineType;
Eurocode?: string;
LanguageCode?: string;
/**
 * Optional sorting parameter. Sorts the guides by the specified field in ascending or descending order. Format: 'field:direction' (e.g., 'status:asc', 'createdAt:desc').
 */
Sort?: GetApiAdminGuidesSort;
Page?: number;
PageSize?: number;
};

export interface VehicleLookupResult {
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  engineTypes?: EngineType[] | null;
  /** @nullable */
  errorMessage?: string | null;
  /** @nullable */
  eurocode?: string | null;
  /** @nullable */
  model?: string | null;
  /** @nullable */
  modelYear?: number | null;
  success?: boolean;
}

export interface VehicleInfo {
  /**
   * @minLength 0
   * @maxLength 10
   * @nullable
   */
  engineBaseType?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   * @nullable
   */
  euroCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  modelSeries?: string | null;
  /** @nullable */
  modelYear?: number | null;
}

export interface VehicleFilterRequest {
  engineBaseType?: EngineType;
  /** @nullable */
  euroCode?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  modelSeries?: string | null;
  /** @nullable */
  modelYearMax?: number | null;
  /** @nullable */
  modelYearMin?: number | null;
}

export interface VehicleFilter {
  /** @nullable */
  engineBaseType?: string | null;
  /** @nullable */
  euroCode?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  modelSeries?: string | null;
  /** @nullable */
  modelYearMax?: number | null;
  /** @nullable */
  modelYearMin?: number | null;
}

export interface VehicleContextSummary {
  /** @nullable */
  engineBaseType?: string | null;
  /** @nullable */
  euroCode?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  modelSeries?: string | null;
  /** @nullable */
  modelYear?: number | null;
}

export interface UserContextSummary {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oid?: string | null;
  /** @nullable */
  upn?: string | null;
}

export interface User {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  id?: string | null;
  isActive?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  roles?: string[] | null;
}

export interface UpdatedByEntry {
  at: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  oid: string;
  /**
   * @minLength 3
   * @maxLength 320
   */
  upn: string;
}

export interface TopUser {
  count?: number;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
}

export interface UserStatsMetrics {
  /** @nullable */
  mostActiveViewers?: TopUser[] | null;
  /** @nullable */
  topGuideCreators?: TopUser[] | null;
  /** @nullable */
  topNonSolvers?: TopUser[] | null;
  /** @nullable */
  topSolvers?: TopUser[] | null;
}

export interface TopGuide {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  problem?: string | null;
  upVotes?: number;
  viewCount?: number;
}

export interface StringStringBooleanStringFAnonymousType15 {
  debug_mode?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  version?: string | null;
}

export interface SearchHistorySummary {
  embedding?: EmbeddingContextSummary;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  locale?: string | null;
  /** @nullable */
  problem?: string | null;
  requestedAt?: string;
  resultCount?: number;
  /** @nullable */
  topResultScore?: number | null;
  /** @nullable */
  translatedProblem?: string | null;
  user?: UserContextSummary;
  vehicle?: VehicleContextSummary;
}

export interface SearchCluster {
  averageSimilarity?: number;
  clusterSize?: number;
  /** @nullable */
  commonProblems?: string[] | null;
  /** @nullable */
  representativeSearches?: SearchHistorySummary[] | null;
}

export interface SearchHistoryClusterResponse {
  /** @nullable */
  clusters?: SearchCluster[] | null;
  endDate?: string;
  metadata?: ClusteringMetadata;
  startDate?: string;
  totalSearchesAnalyzed?: number;
}

export interface SearchClientResult {
  guide?: Guide;
  /** @nullable */
  guideId?: string | null;
  /** @nullable */
  matchedFilter?: VehicleFilter | null;
  /** @nullable */
  motivation?: string | null;
  rank?: number;
  vectorScore?: number;
}

export interface SearchClientRequest {
  /** @nullable */
  locale?: string | null;
  page?: number;
  pageSize?: number;
  /** @nullable */
  problem?: string | null;
  vehicle?: VehicleInfo;
}

export interface SearchClientMetadata {
  processedAt?: string;
  processingTime?: string;
  /** @nullable */
  searchStrategy?: string | null;
  totalResults?: number;
}

export interface SearchClientResponse {
  metadata?: SearchClientMetadata;
  /** @nullable */
  requestId?: string | null;
  /** @nullable */
  results?: SearchClientResult[] | null;
}

export interface RootVehicleRequest {
  engineBaseType?: EngineType;
  /** @nullable */
  euroCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  modelSeries?: string | null;
  /**
   * @minimum 1900
   * @maximum 2030
   * @nullable
   */
  modelYear?: number | null;
}

export interface RootVehicle {
  /** @nullable */
  engineBaseType?: string | null;
  /** @nullable */
  euroCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   * @nullable
   */
  modelSeries?: string | null;
  /** @nullable */
  modelYear?: number | null;
}

export type ResolutionFeedback = typeof ResolutionFeedback[keyof typeof ResolutionFeedback];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolutionFeedback = {
  NoInput: 'NoInput',
  Solved: 'Solved',
  NotSolved: 'NotSolved',
} as const;

export interface PageLink {
  isCurrent?: boolean;
  page?: number;
  /** @nullable */
  url?: string | null;
}

export interface Pages {
  current?: number;
  endIndex?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  /** @nullable */
  links?: PageLink[] | null;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  startIndex?: number;
  total?: number;
  totalResults?: number;
}

export interface SearchHistoryResponse {
  pages?: Pages;
  /** @nullable */
  searches?: SearchHistorySummary[] | null;
  totalCount?: number;
}

export interface ModelYearInsight {
  engagementPercentage?: number;
  modelYear?: number;
  notSolved?: number;
  notSolvedPercentage?: number;
  solved?: number;
  solvedPercentage?: number;
  views?: number;
}

export interface ModelInsight {
  engagementPercentage?: number;
  /** @nullable */
  engineTypes?: EngineTypeInsight[] | null;
  /** @nullable */
  model?: string | null;
  notSolved?: number;
  notSolvedPercentage?: number;
  solved?: number;
  solvedPercentage?: number;
  views?: number;
}

export interface GuidesResponse {
  /** @nullable */
  guides?: Guide[] | null;
  pages?: Pages;
  totalCount?: number;
}

export interface GuideViewResponse {
  /** @nullable */
  guideId?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  requestId?: string | null;
  resolutionFeedback?: ResolutionFeedback;
  /** @nullable */
  resolutionFeedbackAt?: string | null;
  viewedAt?: string;
}

export interface GuideViewRequest {
  /** @minLength 1 */
  guideId: string;
  /** @minLength 1 */
  requestId: string;
}

export interface GuideViewListResponse {
  page?: number;
  pages?: Pages;
  pageSize?: number;
  totalCount?: number;
  /** @nullable */
  views?: GuideViewResponse[] | null;
}

export interface GuideViewFeedbackRequest {
  /** @minLength 1 */
  guideViewId: string;
  resolutionFeedback: ResolutionFeedback;
}

export interface GuideTranslationRequest {
  /** @nullable */
  comment?: string | null;
  /**
   * @minLength 2
   * @maxLength 10
   */
  locale: string;
  /** @nullable */
  possibleCause?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  problem: string;
  /** @nullable */
  problemExpertInput?: string | null;
  /** @nullable */
  problemUserGeneratedInput?: string | null;
  /** @minItems 1 */
  solutions: string[];
}

export interface GuideTranslation {
  /** @nullable */
  comment?: string | null;
  /**
   * @minLength 2
   * @maxLength 10
   */
  locale: string;
  /** @nullable */
  possibleCause?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  problem: string;
  /** @nullable */
  problemExpertInput?: string | null;
  /** @nullable */
  problemUserGeneratedInput?: string | null;
  /** @minItems 1 */
  solutions: string[];
}

export type GuideStatus = typeof GuideStatus[keyof typeof GuideStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuideStatus = {
  Draft: 'Draft',
  Published: 'Published',
  Archived: 'Archived',
} as const;

/**
 * @nullable
 */
export type GuideStatsMetricsGuidesByBrand = {[key: string]: number} | null;

export interface GuideStatsMetrics {
  /** @nullable */
  guidesByBrand?: GuideStatsMetricsGuidesByBrand;
  /** @nullable */
  mostUpVotedGuides?: TopGuide[] | null;
  /** @nullable */
  mostViewedGuides?: TopGuide[] | null;
  totalGuides?: number;
}

export interface GuideResponse {
  guide?: Guide;
}

export interface GuideInsightsSummary {
  engagementPercentage?: number;
  noInputPercentage?: number;
  notSolvedPercentage?: number;
  solvedPercentage?: number;
  totalNotSolved?: number;
  totalSolved?: number;
  totalViews?: number;
}

export interface GuideInsightsResponse {
  /** @nullable */
  brandInsights?: BrandInsight[] | null;
  /** @nullable */
  guideId?: string | null;
  summary?: GuideInsightsSummary;
}

export interface GuideEmbedding {
  /**
   * @minLength 0
   * @maxLength 100
   */
  model: string;
  vector: number[];
}

export interface GuideDeleteResponse {
  deleted?: boolean;
}

export interface GuideContentRequest {
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  possibleCause?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  problem: string;
  /** @nullable */
  problemExpertInput?: string | null;
  /** @nullable */
  problemUserGeneratedInput?: string | null;
  /** @minItems 1 */
  solutions: string[];
}

export interface GuideUpsertRequest {
  content: GuideContentRequest;
  /** @nullable */
  filters?: VehicleFilterRequest[] | null;
  /** @nullable */
  id?: string | null;
  rootVehicle?: RootVehicleRequest;
  /**
   * @minLength 2
   * @maxLength 10
   */
  sourceLocale: string;
  status?: GuideStatus;
  /** @nullable */
  translations?: GuideTranslationRequest[] | null;
}

export interface GuideContent {
  /** @nullable */
  comment?: string | null;
  /**
   * @minLength 2
   * @maxLength 10
   */
  locale: string;
  /** @nullable */
  possibleCause?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  problem: string;
  /** @nullable */
  problemExpertInput?: string | null;
  /** @nullable */
  problemUserGeneratedInput?: string | null;
  /** @minItems 1 */
  solutions: string[];
}

export interface Guide {
  content: GuideContent;
  createdAt?: string;
  createdBy: Creator;
  embedding: GuideEmbedding;
  /** @nullable */
  filters?: VehicleFilter[] | null;
  /** @nullable */
  id?: string | null;
  rootVehicle?: RootVehicle;
  /**
   * @minLength 2
   * @maxLength 10
   */
  sourceLocale: string;
  status: GuideStatus;
  translatedToEnglish?: GuideContent;
  /** @nullable */
  translations?: GuideTranslation[] | null;
  updatedAt?: string;
  /** @nullable */
  updatedBy?: UpdatedByEntry[] | null;
}

export interface ErrorResponse {
  /** @nullable */
  error?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  requestId?: string | null;
  timestamp?: string;
}

export interface EngineTypeInsight {
  engagementPercentage?: number;
  /** @nullable */
  engineType?: string | null;
  /** @nullable */
  modelYears?: ModelYearInsight[] | null;
  notSolved?: number;
  notSolvedPercentage?: number;
  solved?: number;
  solvedPercentage?: number;
  views?: number;
}

export type EngineType = typeof EngineType[keyof typeof EngineType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EngineType = {
  ICE: 'ICE',
  BEV: 'BEV',
  PHEV: 'PHEV',
  HEV: 'HEV',
  REX: 'REX',
  Unknown: 'Unknown',
} as const;

export interface EmbeddingContextSummary {
  /** @nullable */
  model?: string | null;
  /** @nullable */
  vector?: number[] | null;
}

export interface Creator {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  oid: string;
  /**
   * @minLength 0
   * @maxLength 320
   */
  upn: string;
}

export interface CreateGuideDraftFromSearchesRequest {
  /**
   * @minLength 2
   * @maxLength 10
   * @nullable
   */
  locale?: string | null;
  /**
   * @minItems 1
   * @maxItems 50
   */
  searchIds: string[];
}

export interface ClusteringMetadata {
  clustersReturned?: number;
  minClusterSize?: number;
  similarityThreshold?: number;
  totalClustersFound?: number;
}

export interface BrandInsight {
  /** @nullable */
  brand?: string | null;
  engagementPercentage?: number;
  /** @nullable */
  models?: ModelInsight[] | null;
  notSolved?: number;
  notSolvedPercentage?: number;
  solved?: number;
  solvedPercentage?: number;
  views?: number;
}





export const getApiAdminGuides = (
    params?: GetApiAdminGuidesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuidesResponse>(
      {url: `/api/admin/guides`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiAdminGuidesQueryKey = (params?: GetApiAdminGuidesParams,) => {
    return [`/api/admin/guides`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAdminGuidesQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminGuides>>, TError = unknown>(params?: GetApiAdminGuidesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuides>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminGuidesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminGuides>>> = ({ signal }) => getApiAdminGuides(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuides>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminGuidesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminGuides>>>
export type GetApiAdminGuidesQueryError = unknown

export const useGetApiAdminGuides = <TData = Awaited<ReturnType<typeof getApiAdminGuides>>, TError = unknown>(
 params?: GetApiAdminGuidesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuides>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminGuidesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiAdminGuides = (
    guideUpsertRequest: GuideUpsertRequest,
 ) => {
      
      
      return customInstance<GuideResponse>(
      {url: `/api/admin/guides`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: guideUpsertRequest
    },
      );
    }
  


export const getPostApiAdminGuidesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminGuides>>, TError,{data: GuideUpsertRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminGuides>>, TError,{data: GuideUpsertRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminGuides>>, {data: GuideUpsertRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminGuides(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminGuidesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminGuides>>>
    export type PostApiAdminGuidesMutationBody = GuideUpsertRequest
    export type PostApiAdminGuidesMutationError = unknown

    export const usePostApiAdminGuides = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminGuides>>, TError,{data: GuideUpsertRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminGuides>>,
        TError,
        {data: GuideUpsertRequest},
        TContext
      > => {

      const mutationOptions = getPostApiAdminGuidesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAdminGuidesGuideId = (
    guideId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideResponse>(
      {url: `/api/admin/guides/${guideId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiAdminGuidesGuideIdQueryKey = (guideId: string,) => {
    return [`/api/admin/guides/${guideId}`] as const;
    }

    
export const getGetApiAdminGuidesGuideIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>, TError = unknown>(guideId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminGuidesGuideIdQueryKey(guideId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>> = ({ signal }) => getApiAdminGuidesGuideId(guideId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(guideId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminGuidesGuideIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>>
export type GetApiAdminGuidesGuideIdQueryError = unknown

export const useGetApiAdminGuidesGuideId = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>, TError = unknown>(
 guideId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminGuidesGuideIdQueryOptions(guideId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putApiAdminGuidesGuideId = (
    guideId: string,
    guideUpsertRequest: GuideUpsertRequest,
 ) => {
      
      
      return customInstance<GuideResponse>(
      {url: `/api/admin/guides/${guideId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: guideUpsertRequest
    },
      );
    }
  


export const getPutApiAdminGuidesGuideIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>, TError,{guideId: string;data: GuideUpsertRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>, TError,{guideId: string;data: GuideUpsertRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>, {guideId: string;data: GuideUpsertRequest}> = (props) => {
          const {guideId,data} = props ?? {};

          return  putApiAdminGuidesGuideId(guideId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiAdminGuidesGuideIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>>
    export type PutApiAdminGuidesGuideIdMutationBody = GuideUpsertRequest
    export type PutApiAdminGuidesGuideIdMutationError = unknown

    export const usePutApiAdminGuidesGuideId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>, TError,{guideId: string;data: GuideUpsertRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiAdminGuidesGuideId>>,
        TError,
        {guideId: string;data: GuideUpsertRequest},
        TContext
      > => {

      const mutationOptions = getPutApiAdminGuidesGuideIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteApiAdminGuidesGuideId = (
    guideId: string,
 ) => {
      
      
      return customInstance<GuideDeleteResponse>(
      {url: `/api/admin/guides/${guideId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiAdminGuidesGuideIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>, TError,{guideId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>, TError,{guideId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>, {guideId: string}> = (props) => {
          const {guideId} = props ?? {};

          return  deleteApiAdminGuidesGuideId(guideId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAdminGuidesGuideIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>>
    
    export type DeleteApiAdminGuidesGuideIdMutationError = unknown

    export const useDeleteApiAdminGuidesGuideId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>, TError,{guideId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAdminGuidesGuideId>>,
        TError,
        {guideId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiAdminGuidesGuideIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiAdminGuidesGuideIdInsights = (
    guideId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideInsightsResponse>(
      {url: `/api/admin/guides/${guideId}/insights`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiAdminGuidesGuideIdInsightsQueryKey = (guideId: string,) => {
    return [`/api/admin/guides/${guideId}/insights`] as const;
    }

    
export const getGetApiAdminGuidesGuideIdInsightsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>, TError = unknown>(guideId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminGuidesGuideIdInsightsQueryKey(guideId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>> = ({ signal }) => getApiAdminGuidesGuideIdInsights(guideId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(guideId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminGuidesGuideIdInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>>
export type GetApiAdminGuidesGuideIdInsightsQueryError = unknown

export const useGetApiAdminGuidesGuideIdInsights = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>, TError = unknown>(
 guideId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdInsights>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminGuidesGuideIdInsightsQueryOptions(guideId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminGuidesGuideIdViews = (
    guideId: string,
    params?: GetApiAdminGuidesGuideIdViewsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideViewListResponse>(
      {url: `/api/admin/guides/${guideId}/views`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiAdminGuidesGuideIdViewsQueryKey = (guideId: string,
    params?: GetApiAdminGuidesGuideIdViewsParams,) => {
    return [`/api/admin/guides/${guideId}/views`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAdminGuidesGuideIdViewsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>, TError = unknown>(guideId: string,
    params?: GetApiAdminGuidesGuideIdViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminGuidesGuideIdViewsQueryKey(guideId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>> = ({ signal }) => getApiAdminGuidesGuideIdViews(guideId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(guideId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminGuidesGuideIdViewsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>>
export type GetApiAdminGuidesGuideIdViewsQueryError = unknown

export const useGetApiAdminGuidesGuideIdViews = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>, TError = unknown>(
 guideId: string,
    params?: GetApiAdminGuidesGuideIdViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdViews>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminGuidesGuideIdViewsQueryOptions(guideId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminGuidesGuideIdTranslatedLocale = (
    guideId: string,
    locale: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideResponse>(
      {url: `/api/admin/guides/${guideId}/translated/${locale}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiAdminGuidesGuideIdTranslatedLocaleQueryKey = (guideId: string,
    locale: string,) => {
    return [`/api/admin/guides/${guideId}/translated/${locale}`] as const;
    }

    
export const getGetApiAdminGuidesGuideIdTranslatedLocaleQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>, TError = unknown>(guideId: string,
    locale: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminGuidesGuideIdTranslatedLocaleQueryKey(guideId,locale);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>> = ({ signal }) => getApiAdminGuidesGuideIdTranslatedLocale(guideId,locale, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(guideId && locale), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminGuidesGuideIdTranslatedLocaleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>>
export type GetApiAdminGuidesGuideIdTranslatedLocaleQueryError = unknown

export const useGetApiAdminGuidesGuideIdTranslatedLocale = <TData = Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>, TError = unknown>(
 guideId: string,
    locale: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminGuidesGuideIdTranslatedLocale>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminGuidesGuideIdTranslatedLocaleQueryOptions(guideId,locale,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminSearchHistory = (
    params?: GetApiAdminSearchHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchHistoryResponse>(
      {url: `/api/admin/search-history`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiAdminSearchHistoryQueryKey = (params?: GetApiAdminSearchHistoryParams,) => {
    return [`/api/admin/search-history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAdminSearchHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistory>>, TError = unknown>(params?: GetApiAdminSearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminSearchHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminSearchHistory>>> = ({ signal }) => getApiAdminSearchHistory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminSearchHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminSearchHistory>>>
export type GetApiAdminSearchHistoryQueryError = unknown

export const useGetApiAdminSearchHistory = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistory>>, TError = unknown>(
 params?: GetApiAdminSearchHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistory>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminSearchHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminSearchHistoryClusters = (
    params?: GetApiAdminSearchHistoryClustersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchHistoryClusterResponse>(
      {url: `/api/admin/search-history/clusters`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiAdminSearchHistoryClustersQueryKey = (params?: GetApiAdminSearchHistoryClustersParams,) => {
    return [`/api/admin/search-history/clusters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAdminSearchHistoryClustersQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>, TError = unknown>(params?: GetApiAdminSearchHistoryClustersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminSearchHistoryClustersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>> = ({ signal }) => getApiAdminSearchHistoryClusters(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminSearchHistoryClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>>
export type GetApiAdminSearchHistoryClustersQueryError = unknown

export const useGetApiAdminSearchHistoryClusters = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>, TError = unknown>(
 params?: GetApiAdminSearchHistoryClustersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistoryClusters>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminSearchHistoryClustersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiAdminSearchHistorySearchIdViews = (
    searchId: string,
    params?: GetApiAdminSearchHistorySearchIdViewsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideViewListResponse>(
      {url: `/api/admin/search-history/${searchId}/views`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiAdminSearchHistorySearchIdViewsQueryKey = (searchId: string,
    params?: GetApiAdminSearchHistorySearchIdViewsParams,) => {
    return [`/api/admin/search-history/${searchId}/views`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAdminSearchHistorySearchIdViewsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>, TError = unknown>(searchId: string,
    params?: GetApiAdminSearchHistorySearchIdViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminSearchHistorySearchIdViewsQueryKey(searchId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>> = ({ signal }) => getApiAdminSearchHistorySearchIdViews(searchId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(searchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiAdminSearchHistorySearchIdViewsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>>
export type GetApiAdminSearchHistorySearchIdViewsQueryError = unknown

export const useGetApiAdminSearchHistorySearchIdViews = <TData = Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>, TError = unknown>(
 searchId: string,
    params?: GetApiAdminSearchHistorySearchIdViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSearchHistorySearchIdViews>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiAdminSearchHistorySearchIdViewsQueryOptions(searchId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiAdminSearchHistoryGenerateGuideDraft = (
    createGuideDraftFromSearchesRequest: CreateGuideDraftFromSearchesRequest,
 ) => {
      
      
      return customInstance<GuideResponse>(
      {url: `/api/admin/search-history/generate-guide-draft`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGuideDraftFromSearchesRequest
    },
      );
    }
  


export const getPostApiAdminSearchHistoryGenerateGuideDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>, TError,{data: CreateGuideDraftFromSearchesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>, TError,{data: CreateGuideDraftFromSearchesRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>, {data: CreateGuideDraftFromSearchesRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdminSearchHistoryGenerateGuideDraft(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminSearchHistoryGenerateGuideDraftMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>>
    export type PostApiAdminSearchHistoryGenerateGuideDraftMutationBody = CreateGuideDraftFromSearchesRequest
    export type PostApiAdminSearchHistoryGenerateGuideDraftMutationError = unknown

    export const usePostApiAdminSearchHistoryGenerateGuideDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>, TError,{data: CreateGuideDraftFromSearchesRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminSearchHistoryGenerateGuideDraft>>,
        TError,
        {data: CreateGuideDraftFromSearchesRequest},
        TContext
      > => {

      const mutationOptions = getPostApiAdminSearchHistoryGenerateGuideDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getHealth = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<StringStringBooleanStringFAnonymousType15>(
      {url: `/health`, method: 'GET', signal
    },
      );
    }
  

export const getGetHealthQueryKey = () => {
    return [`/health`] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown

export const useGetHealth = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiGuideviewsViews = (
    guideViewRequest: GuideViewRequest,
 ) => {
      
      
      return customInstance<GuideViewResponse>(
      {url: `/api/guideviews/views`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: guideViewRequest
    },
      );
    }
  


export const getPostApiGuideviewsViewsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGuideviewsViews>>, TError,{data: GuideViewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiGuideviewsViews>>, TError,{data: GuideViewRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGuideviewsViews>>, {data: GuideViewRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiGuideviewsViews(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGuideviewsViewsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGuideviewsViews>>>
    export type PostApiGuideviewsViewsMutationBody = GuideViewRequest
    export type PostApiGuideviewsViewsMutationError = unknown

    export const usePostApiGuideviewsViews = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGuideviewsViews>>, TError,{data: GuideViewRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiGuideviewsViews>>,
        TError,
        {data: GuideViewRequest},
        TContext
      > => {

      const mutationOptions = getPostApiGuideviewsViewsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putApiGuideviewsViewsGuideViewIdFeedback = (
    guideViewId: string,
    guideViewFeedbackRequest: GuideViewFeedbackRequest,
 ) => {
      
      
      return customInstance<GuideViewResponse>(
      {url: `/api/guideviews/views/${guideViewId}/feedback`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: guideViewFeedbackRequest
    },
      );
    }
  


export const getPutApiGuideviewsViewsGuideViewIdFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>, TError,{guideViewId: string;data: GuideViewFeedbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>, TError,{guideViewId: string;data: GuideViewFeedbackRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>, {guideViewId: string;data: GuideViewFeedbackRequest}> = (props) => {
          const {guideViewId,data} = props ?? {};

          return  putApiGuideviewsViewsGuideViewIdFeedback(guideViewId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiGuideviewsViewsGuideViewIdFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>>
    export type PutApiGuideviewsViewsGuideViewIdFeedbackMutationBody = GuideViewFeedbackRequest
    export type PutApiGuideviewsViewsGuideViewIdFeedbackMutationError = unknown

    export const usePutApiGuideviewsViewsGuideViewIdFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>, TError,{guideViewId: string;data: GuideViewFeedbackRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiGuideviewsViewsGuideViewIdFeedback>>,
        TError,
        {guideViewId: string;data: GuideViewFeedbackRequest},
        TContext
      > => {

      const mutationOptions = getPutApiGuideviewsViewsGuideViewIdFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiGuidesHealthElasticsearch = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/guides/health/elasticsearch`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiGuidesHealthElasticsearchQueryKey = () => {
    return [`/api/guides/health/elasticsearch`] as const;
    }

    
export const getGetApiGuidesHealthElasticsearchQueryOptions = <TData = Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiGuidesHealthElasticsearchQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>> = ({ signal }) => getApiGuidesHealthElasticsearch(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiGuidesHealthElasticsearchQueryResult = NonNullable<Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>>
export type GetApiGuidesHealthElasticsearchQueryError = unknown

export const useGetApiGuidesHealthElasticsearch = <TData = Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiGuidesHealthElasticsearch>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiGuidesHealthElasticsearchQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiGuidesSearch = (
    searchClientRequest: SearchClientRequest,
 ) => {
      
      
      return customInstance<SearchClientResponse>(
      {url: `/api/guides/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchClientRequest
    },
      );
    }
  


export const getPostApiGuidesSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGuidesSearch>>, TError,{data: SearchClientRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiGuidesSearch>>, TError,{data: SearchClientRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiGuidesSearch>>, {data: SearchClientRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiGuidesSearch(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiGuidesSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postApiGuidesSearch>>>
    export type PostApiGuidesSearchMutationBody = SearchClientRequest
    export type PostApiGuidesSearchMutationError = unknown

    export const usePostApiGuidesSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiGuidesSearch>>, TError,{data: SearchClientRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiGuidesSearch>>,
        TError,
        {data: SearchClientRequest},
        TContext
      > => {

      const mutationOptions = getPostApiGuidesSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getApiHealth = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/health`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiHealthQueryKey = () => {
    return [`/api/health`] as const;
    }

    
export const getGetApiHealthQueryOptions = <TData = Awaited<ReturnType<typeof getApiHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiHealth>>> = ({ signal }) => getApiHealth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getApiHealth>>>
export type GetApiHealthQueryError = unknown

export const useGetApiHealth = <TData = Awaited<ReturnType<typeof getApiHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealth>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiHealthResilience = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/health/resilience`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiHealthResilienceQueryKey = () => {
    return [`/api/health/resilience`] as const;
    }

    
export const getGetApiHealthResilienceQueryOptions = <TData = Awaited<ReturnType<typeof getApiHealthResilience>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthResilience>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiHealthResilienceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiHealthResilience>>> = ({ signal }) => getApiHealthResilience(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiHealthResilience>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiHealthResilienceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiHealthResilience>>>
export type GetApiHealthResilienceQueryError = unknown

export const useGetApiHealthResilience = <TData = Awaited<ReturnType<typeof getApiHealthResilience>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthResilience>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiHealthResilienceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiHealthReadiness = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/health/readiness`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiHealthReadinessQueryKey = () => {
    return [`/api/health/readiness`] as const;
    }

    
export const getGetApiHealthReadinessQueryOptions = <TData = Awaited<ReturnType<typeof getApiHealthReadiness>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthReadiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiHealthReadinessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiHealthReadiness>>> = ({ signal }) => getApiHealthReadiness(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiHealthReadiness>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiHealthReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiHealthReadiness>>>
export type GetApiHealthReadinessQueryError = unknown

export const useGetApiHealthReadiness = <TData = Awaited<ReturnType<typeof getApiHealthReadiness>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthReadiness>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiHealthReadinessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiHealthLiveness = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/health/liveness`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiHealthLivenessQueryKey = () => {
    return [`/api/health/liveness`] as const;
    }

    
export const getGetApiHealthLivenessQueryOptions = <TData = Awaited<ReturnType<typeof getApiHealthLiveness>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthLiveness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiHealthLivenessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiHealthLiveness>>> = ({ signal }) => getApiHealthLiveness(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiHealthLiveness>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiHealthLivenessQueryResult = NonNullable<Awaited<ReturnType<typeof getApiHealthLiveness>>>
export type GetApiHealthLivenessQueryError = unknown

export const useGetApiHealthLiveness = <TData = Awaited<ReturnType<typeof getApiHealthLiveness>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiHealthLiveness>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiHealthLivenessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<User>(
      {url: `/api/me`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiMeQueryKey = () => {
    return [`/api/me`] as const;
    }

    
export const getGetApiMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMe>>> = ({ signal }) => getApiMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMe>>>
export type GetApiMeQueryError = unknown

export const useGetApiMe = <TData = Awaited<ReturnType<typeof getApiMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiMe>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuideStatsMetrics>(
      {url: `/api/stats`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatsQueryKey = () => {
    return [`/api/stats`] as const;
    }

    
export const getGetApiStatsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStats>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStats>>> = ({ signal }) => getApiStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStats>>>
export type GetApiStatsQueryError = ErrorResponse

export const useGetApiStats = <TData = Awaited<ReturnType<typeof getApiStats>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStats>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiUserStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserStatsMetrics>(
      {url: `/api/user-stats`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiUserStatsQueryKey = () => {
    return [`/api/user-stats`] as const;
    }

    
export const getGetApiUserStatsQueryOptions = <TData = Awaited<ReturnType<typeof getApiUserStats>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUserStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserStats>>> = ({ signal }) => getApiUserStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUserStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiUserStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserStats>>>
export type GetApiUserStatsQueryError = ErrorResponse

export const useGetApiUserStats = <TData = Awaited<ReturnType<typeof getApiUserStats>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserStats>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiUserStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiVehicleLookupRegistrationNumber = (
    registrationNumber: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleLookupResult>(
      {url: `/api/vehicle-lookup/${registrationNumber}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiVehicleLookupRegistrationNumberQueryKey = (registrationNumber: string,) => {
    return [`/api/vehicle-lookup/${registrationNumber}`] as const;
    }

    
export const getGetApiVehicleLookupRegistrationNumberQueryOptions = <TData = Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>, TError = unknown>(registrationNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiVehicleLookupRegistrationNumberQueryKey(registrationNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>> = ({ signal }) => getApiVehicleLookupRegistrationNumber(registrationNumber, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(registrationNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiVehicleLookupRegistrationNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>>
export type GetApiVehicleLookupRegistrationNumberQueryError = unknown

export const useGetApiVehicleLookupRegistrationNumber = <TData = Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>, TError = unknown>(
 registrationNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiVehicleLookupRegistrationNumber>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiVehicleLookupRegistrationNumberQueryOptions(registrationNumber,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




